import { render, staticRenderFns } from "./Remote.vue?vue&type=template&id=412ddd6a&scoped=true&"
import script from "./Remote.vue?vue&type=script&lang=js&"
export * from "./Remote.vue?vue&type=script&lang=js&"
import style0 from "./Remote.vue?vue&type=style&index=0&id=412ddd6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412ddd6a",
  null
  
)

export default component.exports